<template>
  <section>
<!--    <div v-for="(home_route, index) in routes" :key="index">-->
    <el-menu
      background-color="#304156"
      text-color="#fff"
      active-text-color="#409EFF"
      :default-active="activeMenu"
      :collapse="isCollapse"
      :unique-opened="false"
      :collapse-transition="false"
      mode="vertical"
    >
        <sidebar-item :isCollapse="isCollapse" v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
<!--    </div>-->
  </section>
</template>

<script>
import SidebarItem from './SidebarItem'
import {getMyRole} from '@/api/api.js'

export default {
  name: 'leftMenu',
  components: {
    SidebarItem,
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      // isCollapse: false,
      routes: []
    }
  },
  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      // return variables
    },
    // isCollapse() {
      // return !this.sidebar.opened
    // }
  },
  mounted() {

    this.initRole();
  },
  methods: {
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    // 初始化菜单，根据已有权限显示相应菜单
    async initRole() {

      await this.$store.dispatch('getCompanyInfo');
      const company_info = this.$store.state.companyInfo;

      const userString = sessionStorage.getItem('user');
      const user = userString ? JSON.parse(userString) : null;

      const routes = this.$router.options.routes;

      if (user.is_admin) {
        this.routes = routes;
      } else {
        const response = await getMyRole({});
        const view_permissions = response.data.data.view_permissions;
        window.sessionStorage.setItem('view_permissions', JSON.stringify(view_permissions))
        this.routes = this.filterRoutes(routes, view_permissions);
      }

      // 功能菜单开关过滤
      this.routes = this.filterRoutesByRequired(this.routes, company_info);
    },

    // 菜单路由过滤
    filterRoutes(routes, filters) {

      const newRoutes = [];

      for (const route of routes) {

        if (filters.includes(route.path)) {
          newRoutes.push(route);
        } else if (route.children) {
          const newRoute = Object.assign({}, route);
          newRoute.children = this.filterRoutes(newRoute.children, filters);
          if (newRoute.children.length) newRoutes.push(newRoute)
        }
      }

      return newRoutes;
    },

    // 功能菜单过滤
    filterRoutesByRequired(routes, config) {

      const newRoutes = [];

      for (const route of routes) {

        const resolved = this.isResolvedRoute(route.required, config);
        if (!resolved) continue

        const newRoute = Object.assign({}, route);

        if (route.children) {
          newRoute.children = this.filterRoutesByRequired(newRoute.children, config);
        }

        if (!newRoute.children || newRoute.children.length) newRoutes.push(newRoute)
      }

      return newRoutes;
    },

    isResolvedRoute(required_params, config) {

      if ('string' === typeof required_params) required_params = [ required_params ];
      if (Array.isArray(required_params)) {
        for (const param of required_params) {
          if (!config[param]) return false;
        }
      }

      return true;
    }
  }
}
</script>

<style>
.el-menu {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/leftMenu.vue